import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiCreateCashIn, ApiCreateTransferPL, ApiDeleteCashIn, ApiDeleteCustomerCard, ApiDeleteTransferPL, ApiGetBankList, ApiGetCardVendorList, ApiGetCashInById, ApiGetCustomerCard, ApiGetCustomerList, ApiGetTransactionCustomerCard, ApiGetTransferPLById, ApiInsertCustomerCard, ApiUpdateCashIn, ApiUpdateCustomerCard, ApiUpdateTransferPL } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { decimal, GetStatus, money, removeNonNumeric, CreditCardNumberFormat } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"
import Select from 'react-select'

export default function TransferPLForm(){
    const navigate = useNavigate()

    const { fetch: apiInsertCashIn } = useFetch(ApiCreateCashIn)
    const { fetch: apiUpdateCashIn } = useFetch(ApiUpdateCashIn)
    const { fetch: apiDeleteCashIn } = useFetch(ApiDeleteCashIn)
    const { fetch: apiGetCashInById } = useFetch(ApiGetCashInById)

    const { fetch: apiInsertTransferPL } = useFetch(ApiCreateTransferPL)
    const { fetch: apiUpdateTransferPL } = useFetch(ApiUpdateTransferPL)
    const { fetch: apiDeleteTransferPL } = useFetch(ApiDeleteTransferPL)
    const { fetch: apiGetTransferPLById } = useFetch(ApiGetTransferPLById)
    const { fetch: apiGetCustomerCardList } = useFetch(ApiGetTransactionCustomerCard)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerCardId = queryString.get("customerCardId")
    let paramCashInId = queryString.get("cashInId")
    let paramTransferPLId = queryString.get("transferPLId")

    // Customer Info State

    const [cashInDate, setCashInDate] = useState(new Date())
    const [transferPLDate, setTransferPLDate] = useState(new Date())
    const [amount, setAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [customerCardId, setCustomerCardId] = useState(EmptyString)
    const [transferSourceOptions, setTransferSourceOptions] = useState(JSON.parse(localStorage.getItem("TransferSource")) || [])
    const [transferSourceId, setTransferSourceId] = useState(EmptyString)

    // Form State

    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorCardNumber, setErrorCardNumber] = useState(false)
    const [errorBankId, setErrorBankId] = useState(false)
    const [errorCardVendorId, setErrorCardVendorId] = useState(false)
    const [errorCustomerId, setErrorCustomerId] = useState(false)
    const [errorExpiredMonth, setErrorExpiredMonth] = useState(false)
    const [errorExpiredYear, setErrorExpiredYear] = useState(false)
    const [errorVcc, setErrorVcc] = useState(false)
    const [errorMdr, setErrorMdr] = useState(false)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        if (formType === FormTypeEdit){
            setLoading({isOpen: true})

            getTransferPLById().then(() => {
                setLoading({isOpen: false})
            })
        }        
    }, [])

    // Function Api Call
    const insertTransferPL = async () => {
        await apiInsertTransferPL({
            data: {
                transferPLDate: moment(transferPLDate).format(InsertDateFormat),
                amount: amount.replaceAll(",", ""),
                remark: remark,
                customerCardId: customerCardId.value,
                transferSourceId: transferSourceId.value
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const updateTransferPL = async () => {
        await apiUpdateTransferPL({
            data: {
                transferPLId: paramTransferPLId,
                transferPLDate: moment(transferPLDate).format(InsertDateFormat),
                amount: amount.replaceAll(",", ""),
                remark: remark,
                customerCardId: customerCardId.value,
                transferSourceId: transferSourceId.value
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getCustomerCardList = async(searchParam) => {
        await apiGetCustomerCardList({
            data: {
                customerName: searchParam,
                cardNumber: EmptyString,
                bankId: 0,
                cardVendorId: 0,
                status: StatusCodeActive,
                pageSize: 50,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: CreditCardNumberFormat(data[i].cardNumber) + " (" + data[i].bankCode.trim() + ") - " + data[i].customerName, value: String(data[i].customerCardId) })
                    }

                    setCustomerCardOptions(tempArray)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getTransferPLById = async () => {
        await apiGetTransferPLById({
            data: {
                transferPLId: parseInt(paramTransferPLId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setTransferPLDate(data.transferPLDate)
                setCustomerCardId({ label: CreditCardNumberFormat(data.cardNumber) + " (" + data.bankCode.trim() + ") - " + data.customerName, value: String(data.customerCardId) })
                setTransferSourceId(transferSourceOptions.find(item => item.value === String(data.transferSourceId)))
                setAmount(money(data.amount))
                setRemark(data.remark)
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const deleteTransferPL = async () => {
        await apiDeleteTransferPL({
            data: {
                transferPLId: parseInt(paramTransferPLId),
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                        setSuccessModal({isOpen: false})
                            navigate(-1) 
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Button Click Handlers
    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if (formType === FormTypeAdd){
                    insertTransferPL().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    updateTransferPL().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            deleteTransferPL().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let isValid = true

        return isValid
    }

    const customerCardOnInput = (e) => {
        getCustomerCardList(e)
    }
    const customerCardChange = (e) => {
        // setLoading({isOpen: true})
        setCustomerCardId(e)
        
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <div className="flex justify-between">
                    <span className="font-semibold text-2xl">Transfer PL Detail</span>
                    <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                        <span className="text-sm opacity-60">
                            Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                        </span>
                    </div>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Transfer PL Date */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Transfer PL Date</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <DatePicker className="h-11 bg-white w-full" value={transferPLDate} onChange={(date) => setTransferPLDate(date)} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCustomerId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Customer is required!</span>
                    </div>
                </div>

                {/* Customer Card */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Customer Card</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 md:w-[500px]">
                                <Select className="" options={customerCardOptions} value={customerCardId} onInputChange={customerCardOnInput} onChange={customerCardChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCardNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Card Number is required!</span>
                    </div>
                </div>

                {/* Amount */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Amount</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={amount} onChange={(e) => setAmount(money(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCardNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Card Number is required!</span>
                    </div>
                </div>

                {/* Remark */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Remark</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={remark} onChange={(e) => setRemark(e.target.value.toUpperCase())} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorBankId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank is required!</span>
                    </div>
                </div>

                {/* Transfer Source */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Transfer Source</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 md:w-[500px]">
                                <Select className="" options={transferSourceOptions} value={transferSourceId} onChange={(e) => setTransferSourceId(e)} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorBankId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank is required!</span>
                    </div>
                </div>
            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}